"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TOGGLE_BLOCKED_COUNTRY_MESSAGE = exports.TOGGLE_BLACK_LIST_MESSAGE = exports.TOGGLE_RATE_LIMIT_MESSAGE = exports.USER_IP_SUCCESS = exports.LOGGING_IN = exports.EMAIL_LINK_INIT = exports.USER_LOGOUT = exports.USER_UNAUTHED = exports.USER_AUTHED = void 0;
var USER_AUTHED = "USER_AUTHED";
exports.USER_AUTHED = USER_AUTHED;
var USER_UNAUTHED = "USER_UNAUTHED";
exports.USER_UNAUTHED = USER_UNAUTHED;
var USER_LOGOUT = "USER_LOGOUT";
exports.USER_LOGOUT = USER_LOGOUT;
var EMAIL_LINK_INIT = "EMAIL_LINK_INIT";
exports.EMAIL_LINK_INIT = EMAIL_LINK_INIT;
var LOGGING_IN = "LOGGING_IN";
exports.LOGGING_IN = LOGGING_IN;
var USER_IP_SUCCESS = "USER_IP_SUCCESS";
exports.USER_IP_SUCCESS = USER_IP_SUCCESS;
var TOGGLE_RATE_LIMIT_MESSAGE = "TOGGLE_RATE_LIMIT_MESSAGE";
exports.TOGGLE_RATE_LIMIT_MESSAGE = TOGGLE_RATE_LIMIT_MESSAGE;
var TOGGLE_BLACK_LIST_MESSAGE = "TOGGLE_BLACK_LIST_MESSAGE";
exports.TOGGLE_BLACK_LIST_MESSAGE = TOGGLE_BLACK_LIST_MESSAGE;
var TOGGLE_BLOCKED_COUNTRY_MESSAGE = "TOGGLE_BLOCKED_COUNTRY_MESSAGE";
exports.TOGGLE_BLOCKED_COUNTRY_MESSAGE = TOGGLE_BLOCKED_COUNTRY_MESSAGE;